import React, { Component } from 'react'
import styled from 'styled-components'
import { FadeIn } from 'animate-css-styled-components'

import ResultItem from 'components/ResultItem'
import Logic from './logic'
import { SITE_URL } from 'config'

@Logic
export default class Results extends Component {
  render () {
    const { results, opened, isCompany } = this.props
    const { setOpened } = this.actions

    /* eslint-disable camelcase */
    return (
      <Wrapper>
        {
          results &&
            results.map(({ id, hi_res_logo, ...item }, index) => {
              if (!hi_res_logo) {
                return false
              }

              const logo = `${SITE_URL}${hi_res_logo}`

              return (
                <FadeInBox duration={`0.4s`} key={`result-${item.id}-${index}`} delay={`${index * 0.02}s`}>
                  <ResultItem
                    key={id}
                    {...item}
                    logo={logo}
                    onClick={() => setOpened({ id, ...item })}
                    opened={opened && opened.id === id}
                    isCompany={isCompany}
                  />
                </FadeInBox>
              )
            })
          }
      </Wrapper>
    )
    /* eslint-enable camelcase */
  }
}

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 20px 0;
  margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

const FadeInBox = styled(FadeIn)`
  width: 200px;
  display: inline-block;
  vertical-align: top;
  align-self: flex-start;

  @media screen and (max-width: 1024px) {
    width: 200px;
  }

  @media screen and (max-width: 768px) {
    width: 180px;
  }

  @media screen and (max-width: 425px) {
    width: 130px;
  }

`



// WEBPACK FOOTER //
// ./src/containers/Results/index.js